export default {
    meta: {
        title: '加盟商管理搜索',
        url: '/fishtogether/franchiseelist',
        urlName: '鱼你加盟商管理',
    }
};
